var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"logout-button",on:{"click":_vm.logout}},[_c('Icon',{attrs:{"name":"sign-out"}}),_vm._v(" Log out ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }